import { render, staticRenderFns } from "./Devedor.vue?vue&type=template&id=74ae680d&scoped=true&"
import script from "./Devedor.vue?vue&type=script&lang=js&"
export * from "./Devedor.vue?vue&type=script&lang=js&"
import style0 from "./Devedor.vue?vue&type=style&index=0&id=74ae680d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae680d",
  null
  
)

export default component.exports